import * as Yup from "yup";



export const initialValues = {
  isAllPosition: 'Y',
  conditionByPosition: [
    {
      leavePermissionTime: {
        positionId: '',
        determineByWorkExp: 'N',
        durationTime: [
          {
            haveWorkFor: null,
            haveWorkForUnit: null,
            butLessThan: null,
            butLessThanUnit: null,
            leaveDay: null,
            leaveHour: null,
            unlimited: 'N',
            prorate: 'N',
          },
        ],
      },
    },
  ],
  conditionForAllPosition: {
    leavePermissionTime: {
      determineByWorkExp: 'N',
      durationTime: [
        {
          haveWorkFor: null,
          haveWorkForUnit: null,
          butLessThan: null,
          butLessThanUnit: null,
          leaveDay: null,
          leaveHour: null,
          unlimited: 'N',
          prorate: 'N',
        },
      ],
    },
  },
};

const LeaveTypeEntitleSchema = Yup.object().shape({
  // leaveTypeName: Yup.string().required("Please enter."),
  // leaveTypeNameEn: Yup.string().required("Please enter."),
  // leaveGroupId: Yup.string().required("Please select."),
  // description: Yup.string().required("Please enter."),
});

export default LeaveTypeEntitleSchema;
